import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GoogleMapsEmbedIframeDialogComponentData {
  title?: string;
  googleMapsEmbedLink: string;
}

@Component({
  selector: 'app-google-maps-embed-iframe-dialog',
  templateUrl: './google-maps-embed-iframe-dialog.component.html',
  styleUrls: ['./google-maps-embed-iframe-dialog.component.scss'],
})
export class GoogleMapsEmbedIframeDialogComponent {
  public title: string;
  public googleMapsEmbedLink: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: GoogleMapsEmbedIframeDialogComponentData,
    private dialogRef: MatDialogRef<GoogleMapsEmbedIframeDialogComponent>
  ) {
    this.title = this.data?.title;
    this.googleMapsEmbedLink = this.data?.googleMapsEmbedLink;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
